module.exports = __webpack_public_path__ + "components/weather-icon/static/daylightrain-070dcf9f7acdb1d4679b0edeb0659c96.webp";